import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { VideoCardWithTags } from "../../Video";
import { VideoStatus } from "@parkschannel/contracts";
import { UserVideoCardDropdown } from "./UserVideoCardDropdown";
export const VideoCardWithTagsAndStatus = (param)=>{
    let { data , ...rest } = param;
    return /*#__PURE__*/ _jsx(VideoCardWithTags, {
        data: data,
        ...rest,
        thumbnailClassName: "h-[190px]",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "absolute top-4 left-5 right-5 flex justify-between items-center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: classNames("bg-white text-neutral-700 py-1 px-2 rounded-full text-xs capitalize", {
                        invisible: data.status === VideoStatus.PUBLISHED
                    }),
                    children: data.status === VideoStatus.WAITING_FOR_APPROVAL ? "Waiting for approval" : data.status
                }),
                /*#__PURE__*/ _jsx("div", {
                    onClick: (e)=>e.stopPropagation(),
                    children: /*#__PURE__*/ _jsx(UserVideoCardDropdown, {
                        data: data
                    })
                })
            ]
        })
    });
};
